<template>
  <card class="card">
    <h4 class="text-center">Tracked Match IDs</h4>
    <div class="row">
      <div class="col-md-6 text-left">
        <a href="#" @click.prevent="refreshTrackedMatches()">
          <em class="tim-icons icon-refresh-02" :class="refreshingAnimation" style="font-size: 22px; margin-bottom: 10px; margin-top: 10px"></em>
        </a>
      </div>
      <div class="col-md-6 text-right">
        <button type="button" class="btn btn-primary mb-4 float-right" @click="showAddMatchDialog = true; formAction = 'Add'">
          Add Match
        </button>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="matchIds"
      theme="nocturnal"
      :search-options="{
        enabled: true
      }"
      :pagination-options="{
        enabled: true,
        perPage: 10,
        allLabel: 'All',
      }"
    >
      <div slot="emptystate">
        <span v-show="isLoading">Loading...</span>
        <span v-show="!isLoading">There are no tracked matches.</span>
      </div>

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'notes'" v-html="processNotes(props.row.notes)"></span>
        <span v-else-if="props.column.field == 'created_at'">
          {{ formatDateTime(props.row.created_at) }}
        </span>
        <span v-else-if="props.column.field == 'actions'">
          <base-button icon round @click="deleteTrackedMatchId(props.row.id)">
            <i class="tim-icons icon-trash-simple"></i>
          </base-button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <add-match-to-track-dialog :showAddMatchDialog="showAddMatchDialog" @close="showAddMatchDialog = false" @added="refreshTrackedMatches()" />
  </card>
</template>

<script>
import axios from "axios";
import formatDateTime from "../mixin/formatDateTime";
import AddMatchToTrackDialog from "../components/AddMatchToTrackDialog.vue";

export default {
  name: "TrackedMatchIds",
  mixins: [formatDateTime],
  components: {
    AddMatchToTrackDialog
  },
  data() {
    return {
      showAddMatchDialog: false,
      isLoading: true,
      isRefreshing: false,
      refreshingAnimation: "",
      matchIds: [],
      columns: [
        { label: 'Match ID', field: 'match_id' },
        { label: 'Match Name', field: 'match_name' },
        { label: 'Notes', field: 'notes' },
        { label: "Created at", field: "created_at" },
        { label: 'Actions', field: 'actions', sortable: false, width: "120px" }
      ]
    };
  },
  watch: {
    isRefreshing() {
      if (this.isRefreshing) {
        this.refreshingAnimation = "rotating";
      } else {
        this.refreshingAnimation = "";
      }
    }
  },
  mounted() {
    this.getTrackedMatchIds();
  },
  methods: {
    processNotes(notes) {
      if (!notes) {
        return;
      }
      return notes.replace(/\n/g, '<br>');
    },
    getTrackedMatchIds() {
      this.isLoading = true;
      axios.get('/tracked-games')
        .then(response => {
          this.matchIds = response.data;
        })
        .catch(error => {
          console.error("Error fetching tracked match IDs:", error);
        }).finally(() => {
          this.isLoading = false;
          this.isRefreshing = false;
        });
    },
    deleteTrackedMatchId(id) {
      axios.delete(`/tracked-games/${id}`)
        .then(() => {
          this.getTrackedMatchIds(); // Refresh list after delete
        })
        .catch(error => {
          console.error("Error deleting tracked match ID:", error);
        });
    },
    refreshTrackedMatches() {
      this.isRefreshing = true;
      this.getTrackedMatchIds();
    }
  }
};
</script>
